import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { QcResponseGrid } from 'src/app/shared/models/grid.model';
import { IS_LOAD, IS_SEARCH } from 'src/app/shared/models/load.models';
import { EnvironmentFacadeService } from 'src/app/shared/services/environment.facade.service';
import { PaginatorFacadeService } from 'src/app/shared/services/paginator.facade.service';
import {
  CountriesResponse,
  CustomCampaignSearchPayload,
  SchemaResponse,
} from '../models/campaign-management.model';
import { CampaignManagementFacadeService } from './search.facade.service';

@Injectable({ providedIn: 'root' })
export class CampaignExecutionsService {
  constructor(
    private http: HttpClient,
    private environmentFacade: EnvironmentFacadeService,
    private cmFacade: CampaignManagementFacadeService,
    private paginatorFacade: PaginatorFacadeService,
  ) {}

  schemas(): Observable<SchemaResponse> {
    const url = this.environmentFacade.getEnvironment() + '/rest/v1/loyalty/schemas';

    return this.http.get<SchemaResponse>(url, {
      withCredentials: true,
      context: new HttpContext().set(IS_LOAD, true),
    });
  }

  countries(): Observable<CountriesResponse> {
    const url = this.environmentFacade.getEnvironment() + '/rest/v1/system/countries';

    return this.http.get<CountriesResponse>(url, {
      withCredentials: true,
      context: new HttpContext().set(IS_LOAD, true),
    });
  }

  channels(): Observable<any[]> {
    const url =
      this.environmentFacade.getEnvironment() + '/rest/v1/campaigns/communication-channels';

    return this.http.get<any[]>(url, {
      withCredentials: true,
      context: new HttpContext().set(IS_LOAD, true),
    });
  }

  search(): Observable<QcResponseGrid> {
    const url = this.environmentFacade.getEnvironment() + '/rest/v1/campaigns/executions';

    const body: CustomCampaignSearchPayload = {
      pageSize: this.paginatorFacade.itemsNumber,
      sortField: this.paginatorFacade.selectedSortField ? 'EXECUTION_DATE' : 'EXECUTION_DATE',
      sortOrder: this.paginatorFacade.selectedOrder === 'Ascending' ? 'ASC' : 'DESC',
      start: this.paginatorFacade.pageIndex * this.paginatorFacade.itemsNumber,
    };

    if (this.cmFacade.campaignName) body.campaignName = this.cmFacade.campaignName;
    if (this.cmFacade.channel) body.channel = this.cmFacade.channel;
    if (this.cmFacade.countryId) body.countryId = this.cmFacade.countryId;
    if (this.cmFacade.startDateFormat) body.executedFromDate = this.cmFacade.startDateFormat;
    if (this.cmFacade.endDateFormat) body.executedUntilDate = this.cmFacade.endDateFormat;
    if (this.cmFacade.schemaId) body.loyaltySchemaId = this.cmFacade.schemaId;

    return this.http.post<QcResponseGrid>(url, body, {
      withCredentials: true,
      context: new HttpContext().set(IS_SEARCH, true),
    });
  }

  count(): Observable<number> {
    const url = this.environmentFacade.getEnvironment() + '/rest/v1/campaigns/executions/count';

    const body: CustomCampaignSearchPayload = {
      pageSize: this.paginatorFacade.itemsNumber,
      sortField: this.paginatorFacade.selectedSortField ? 'EXECUTION_DATE' : 'EXECUTION_DATE',
      sortOrder: this.paginatorFacade.selectedOrder === 'Ascending' ? 'ASC' : 'DESC',
      start: this.paginatorFacade.pageIndex * this.paginatorFacade.itemsNumber,
    };

    if (this.cmFacade.campaignName) body.campaignName = this.cmFacade.campaignName;
    if (this.cmFacade.channel) body.channel = this.cmFacade.channel;
    if (this.cmFacade.countryId) body.countryId = this.cmFacade.countryId;
    if (this.cmFacade.startDateFormat) body.executedFromDate = this.cmFacade.startDateFormat;
    if (this.cmFacade.endDateFormat) body.executedUntilDate = this.cmFacade.endDateFormat;
    if (this.cmFacade.schemaId) body.loyaltySchemaId = this.cmFacade.schemaId;

    return this.http.post<number>(url, body, {
      withCredentials: true,
      context: new HttpContext().set(IS_SEARCH, true),
    });
  }
}
